import EventManager from '@buzzfeed/adlib/core/event-manager';
import { CLUSTER, BF_URL } from '../constants';
import { sizes, programmaticSizes } from '../constants/ads';
import { rules } from '@buzzfeed/consent';


const eventBus = new EventManager();

const env = {
    adSizes: sizes,
    programmaticSizes,
    destination: 'bfd.bio',
    hasQuiz: false,
    isAsIs: false,
    isBFN: false,
    isBFO: false,
    isBPage: false,
    isDev: (CLUSTER === 'dev'),
    isE2ETest: false,
    isFeed: false,
    isFeedPage: false,
    isFeedpager: false,
    isHomePage: false,
    isNewsPost: false,
    isPharmaceutical: false,
    isProd: (CLUSTER === 'prod'),
    isWidePost: false,
    locale: 'en_US',
    localization: {
        country: 'en-us',
        language: 'en',
        locale: 'en_US',
    },
    localizationCountry: 'en-us',
    pageFilter: null,
    pageFilters: {},
    pageMainFilter: null,
    type: CLUSTER,
    webRoot: BF_URL,
};

const localization = {
    getEdition() { return 'en-us'; },
    getRawPageLanguage() { return 'en'; },
};


export async function getContext({
    page,
    needsConsent,
    getFeatureFlagValue,
    getExperimentValue,
}) {
    let gdpr; let ccpa;
    if (needsConsent) {
        gdpr = {
            needsConsent: true,
            hasConsented() {
                return rules.hasConsented('ads');
            },
            hasConsentedTracking() {
                return rules.hasConsented('tracking');
            },
            hasConsentedGoogle() {
                return rules.hasConsented('google');
            },
            // buzzblocks permutive uses raw `getVendorConsents` and checks for its vendor ids
            getVendorConsents() {
                return rules.fetchRawVendorConsents(...arguments);
            },
            hasOptedOutCCPA() {
                return rules.fetchCCPAValue();
            },
            fetchAdPurposeConsent() {
                return rules.hasConsented('ads');
            },
        };
        ccpa = {
            getConsentValue() {
                return rules.fetchCCPAValue();
            },
        };
    } else {
        gdpr = {
            needsConsent: false,
            hasConsented() {
                return Promise.resolve(true);
            },
            hasConsentedTracking() {
                return Promise.resolve(true);
            },
            hasConsentedGoogle() {
                return Promise.resolve(true);
            },
            getVendorConsents() {
                return Promise.resolve({
                    data: {
                        purposeConsents: {},
                        vendorConsents: {},
                    },
                });
            },
            hasOptedOutCCPA() {
                return Promise.resolve(false);
            },
            fetchAdPurposeConsent() {
                return Promise.resolve(true);
            },
        };
        ccpa = {
            getConsentValue() {
                // `null` is a valid value according to IAB
                return Promise.resolve(null);
            },
        };
    }

    const abeagle = {
        getExperimentVariant() {
            return Promise.resolve().then(() => getExperimentValue(...arguments));
        },
        isOn() {
            return Promise.resolve().then(() => getFeatureFlagValue(...arguments));
        },
    };

    const pageType = page.pageType;
    // that's right, we're mutating the `env` object
    // so that adlib core (ads.js) can use the updated values
    // (since it initializes only once on first load)
    Object.assign(env, {
        allPageSections: ['bfd.bio', pageType],
        author: null,
        cmsTags: [],
        pageSection: pageType,
        pageCategory: pageType,
        pageName: pageType,

        isAdPost() {
            return false;
        },
    });

    return { eventBus, env, gdpr, ccpa, abeagle, localization, tracking: {} };
}
